import Service from "../Service";
const resource = "TicEquipmentAssignamentNew/";

export default {
  save(cmp, requestID) {
    return Service.post(resource + "save", cmp, {
      params: { requestID: requestID },
    });
  },

  pagination(parameters, requestID) {
    return Service.post(resource + "pagination", parameters, {
      params: { requestID: requestID },
    });
  },

  list(EanID, Devolution, requestID) {
    return Service.post(
      resource + "list",
      {},
      {
        params: { EanID, Devolution, requestID },
      }
    );
  },

  assignamentWithUsersExpired(parameters, requestID) {
    return Service.post(resource + "assignamentWithUsersExpired", parameters, {
      params: { requestID },
    });
  },

  saveDevolution(obj, requestID) {
    return Service.post(resource + "saveDevolution", obj, {
      params: { requestID: requestID },
    });
  },

  listDevolution(EanID, requestID) {
    return Service.post(
      resource + "listDevolution",
      {},
      {
        params: { EanID: EanID, requestID: requestID },
      }
    );
  },

  excel(params, requestID) {
    return Service.post(resource + "excel", params, {
      params: { requestID },
      responseType: "blob",
      headers: {
        "Content-Type": "application/json",
      },
    });
  },
};
